import { useTranslation } from 'react-i18next';

function FlexibilitySection() {
  const { t } = useTranslation();

  const getArrayTranslation = (key) => {
    const value = t(key, { returnObjects: true });

    return Array.isArray(value) ? value : [];
  };

  const items = getArrayTranslation('flexibility.items');

  return (
    <section id="flexibility" className="section flexibility-section">
      <div className="flexibility-card">
        <div className="flexibility-content">
          <div className="eyebrow">{t('flexibility.eyebrow')}</div>
          <h2>{t('flexibility.title')}</h2>
          <p>{t('flexibility.description')}</p>

          <a href="#contact" className="button primary">
            {t('flexibility.cta')}
          </a>
        </div>

        <div className="flexibility-list" aria-label={t('flexibility.aria')}>
          {items.map((item) => (
            <article className="flexibility-item" key={item.title}>
              <span>{item.number}</span>
              <div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FlexibilitySection;
